import { defineMessages } from "react-intl";

const messages = defineMessages({
    viewTask: {
        id: "test.taskCard.view",
    },
    editTask: {
        id: "test.taskCard.edit",
    },
    delete: {
        id: "general.delete",
    },
    alert: {
        id: "test.taskCard.notEdited",
    },
    deleteTaskModalTitle: {
        id: "test.deleteTaskModal.title",
    },
    deleteTaskModalAreYouSure: {
        id: "test.deleteTaskModal.areYouSure",
    },
    cancel: {
        id: "general.cancel",
    },
    description: {
        id: "homework.description.studentSide",
    },
    save: {
        id: "changeDescription.submit"
    },
    modifySomething: {
        id: "account.modal.changeSomething"
    }
});

export default messages;
